import "./styles.scss";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

import { awayTimeType } from "../../utils/event";

import { CalendarEventBody, CalendarEventTime, CalendarEventTitle } from "./CalendarEvent";

const AwayTime = ({ position, startTime, endTime, type, details, label }) => {
  const title = label ? label : "Out of Office";

  return (
    <CalendarEventBody
      className="AwayTime__body"
      details={details}
      endTime={endTime}
      position={position}
      startTime={startTime}
    >
      <CalendarEventTitle title={title} />
      <CalendarEventTime endTime={endTime} startTime={startTime} strikeTimes={type?.isCancelled} />
    </CalendarEventBody>
  );
};

AwayTime.propTypes = {
  position: PropTypes.object,
  startTime: PropTypes.instanceOf(moment),
  endTime: PropTypes.instanceOf(moment),
  type: awayTimeType,
};

export { AwayTime };
